import React from 'react';

import { SaveButton } from '../button/save-button/SaveButton';
import Modal from '../modal/Modal';

export const CancelConfirmationModal = ({ closeCancelModal, setIsCancelModalOpen, handleCancelClick }) => {
  return (
    <Modal
      closeModal={closeCancelModal}
      setIsModalOpen={setIsCancelModalOpen}
      headerTitle={'Confirm Cancel'}
      width={'750px'}
      height={'max-content'}
      contentPadding={'2px'}
      justifyContent={'center'}
      hideButton={true}
    >
      <div className={'modal-container'}>
        <label className={'modal-text'}>Please note if you cancel now all changes will be lost.</label>
        <label className={'modal-text'}>Are you sure you would like to cancel?</label>
      </div>

      <div className="study-button-container">
        <SaveButton
          color={'#ffffff'}
          border={'1px solid #6f8695'}
          textColor={'#6f8695'}
          title={'No'}
          onClick={closeCancelModal}
        />
        <SaveButton
          color={'#ffffff'}
          border={'1px solid #6f8695'}
          textColor={'#6f8695'}
          title={'Yes'}
          onClick={handleCancelClick}
        />
      </div>
    </Modal>
  );
};
